module.exports = __webpack_public_path__ + "img/hip-endomorph-female.c6cb0011.svg";